import { Breadcrumbs as MantineBreadcrumbs, Text } from '@mantine/core';
import { AnchorLink } from 'src/design/molecules/AnchorLink';

export interface IBreadcrumb {
  text: string;
  href?: string;
}

export interface IPageBreadcrumbsProps {
  items: IBreadcrumb[];
}

/** @registry Mantine Breadcrumbs; items with an href render as AnchorLinks, items without render as plain bold text (current page). */
export const PageBreadcrumbs: React.FC<IPageBreadcrumbsProps> = ({ items }) => {
  return (
    <MantineBreadcrumbs mb="md">
      {items.map((item, index) =>
        item.href ? (
          <AnchorLink to={item.href} key={index}>
            {item.text}
          </AnchorLink>
        ) : (
          <Text c="bright" fw={700} key={index}>
            {item.text}
          </Text>
        ),
      )}
    </MantineBreadcrumbs>
  );
};
